var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPorMbWay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59961 10.7998C9.59961 7.4861 12.2859 4.7998 15.5996 4.7998H32.3996C35.7133 4.7998 38.3996 7.4861 38.3996 10.7998V37.1998C38.3996 40.5135 35.7133 43.1998 32.3996 43.1998H32.3496C31.6869 43.1998 31.1496 42.6625 31.1496 41.9998C31.1496 41.3371 31.6869 40.7998 32.3496 40.7998H32.3996C34.3878 40.7998 35.9996 39.188 35.9996 37.1998V10.7998C35.9996 8.81158 34.3878 7.1998 32.3996 7.1998H15.5996C13.6114 7.1998 11.9996 8.81158 11.9996 10.7998V37.1998C11.9996 39.188 13.6114 40.7998 15.5996 40.7998H27.7496C28.4123 40.7998 28.9496 41.3371 28.9496 41.9998C28.9496 42.6625 28.4123 43.1998 27.7496 43.1998H15.5996C12.2859 43.1998 9.59961 40.5135 9.59961 37.1998V10.7998Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9996 35.9998C24.6623 35.9998 25.1996 35.4625 25.1996 34.7998C25.1996 34.1371 24.6623 33.5998 23.9996 33.5998C23.3369 33.5998 22.7996 34.1371 22.7996 34.7998C22.7996 35.4625 23.3369 35.9998 23.9996 35.9998ZM23.9996 38.3998C25.9878 38.3998 27.5996 36.788 27.5996 34.7998C27.5996 32.8116 25.9878 31.1998 23.9996 31.1998C22.0114 31.1998 20.3996 32.8116 20.3996 34.7998C20.3996 36.788 22.0114 38.3998 23.9996 38.3998Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPorMbWay);
export default __webpack_public_path__ + "static/media/iconPorMbWay.8db9954221203c140a98051182e688a3.svg";
export { ForwardRef as ReactComponent };